app.controller('home', function (authService, appConfig, $location) {
  if (!authService.isAuthenticated()) {
    $location.path('/login')
    return
  }

  $location.path('/summary')
})
